module.exports = __webpack_public_path__ + "fonts/icomoon_rrss.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/icomoon_rrss/icomoon_rrss.ttf
// module id = XdMB
// module chunks = 1